import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-flight-round-way-loader',
  templateUrl: './flight-round-way-loader.component.html',
  styleUrls: ['./flight-round-way-loader.component.scss']
})
export class FlightRoundWayLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
